import { render, staticRenderFns } from "./CrmKinhDoanh.vue?vue&type=template&id=487704e3&scoped=true"
import script from "./CrmKinhDoanh.vue?vue&type=script&lang=js"
export * from "./CrmKinhDoanh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487704e3",
  null
  
)

export default component.exports